import { type ReactNode } from 'react'
import type { LinkType } from '../../link-without-prefetch'
import LinkWithoutPrefetch from '../../link-without-prefetch'
import type { BaseButtonType } from '../types/button-interface'

type ButtonLinkWrapperProps = LinkType & Pick<BaseButtonType, 'isLoading'>

const ButtonLinkWrapper = ({
  href,
  isLoading = false,
  className,
  children,
  ...baseLinkProps
}: ButtonLinkWrapperProps): ReactNode => {
  if (baseLinkProps['aria-disabled'] || isLoading) {
    return (
      <button className={className} disabled={!!baseLinkProps['aria-disabled']}>
        {children}
      </button>
    )
  }
  return (
    <LinkWithoutPrefetch className={className} href={href as string} {...baseLinkProps}>
      {children}
    </LinkWithoutPrefetch>
  )
}
export default ButtonLinkWrapper
